<template>
  <CardSection :loading="isSavableStateLoading"
    :error="majorError">
    <template #header>
      {{ createNew ? 'New' : 'Edit' }}
      Notification Service {{ selectedService.name ? `- ${selectedService.name}` : '' }}
    </template>

    <template #body>
      <SubSection>
        <template #body>
          <VeeForm v-if="selectedService" @submit="onSubmit">
            <div class="row">
              <TextInput v-model="selectedService.name"
                name="name"
                label="Name"
                rules="required"
                col-style="form-group-standard-column" />
            </div>
            <div class="row">
              <TextInput v-model="selectedService.phoneNumber" 
                v-mask="'###-###-####'"
                name="phone_number"
                label="Phone to notify"
                rules="required"
                placeholder="123-456-7890"
                col-style="form-group-5-column-large" />
            </div>
            <div class="row">
              <label class="p-label service-label">
                Service Type
              </label>
            </div>
             <div class="row">
              <div class="col-lg-1 col-md-1">
                <div class="form-check form-check-inline">
                  <input id="sms" 
                    v-model="selectedService.sms"
                    class="form-check-input" 
                    type="checkbox"
                    aria-labelledby="sms">
                  <label class="form-check-label" for="sms">SMS</label>
                </div>
              </div>
              <div class="col-lg-1 col-md-1">
                <div class="form-check form-check-inline">
                  <input id="robocall" 
                    v-model="selectedService.robocall"
                    class="form-check-input" 
                    type="checkbox"  
                    aria-labelledby="robocall">
                  <label class="form-check-label" for="robocall">Robocall</label>
                </div>
              </div>
            </div>
            <div class="row">
              <TextArea v-model="selectedService.smsText"
                name="smsText"
                label="SMS Text"
                rows="5"
                cols="100"
                maxlength="500"
                :rules="`${selectedService.sms ? 'required' : ''}`" />
              <TextArea v-model="selectedService.robocallText"
                name="robocallText"
                label="Robocall Text"
                rows="5"
                cols="100"
                maxlength="500"
                :rules="`${selectedService.robocall ? 'required' : ''}`"  />
            </div>
            <ActionToolbar :component-state="currentState" 
              :error-message="formError"  
              :success-message="successMessage" 
              primary-button-text="Save"
              :secondary-button-text="createNew ? 'Cancel' : 'Close'"
              @secondary-click="cancel" />
          </VeeForm>
        </template>
      </SubSection>
    </template>
  </CardSection>
</template>

<script>
import CardSection from "@/src/components/shared/CardSection.vue";
import ActionToolbar from "@/src/components/shared/ActionToolbar.vue";
import { useNotificationServiceStore } from '@/src/stores/notification-service';
import SubSection from "@/src/components/shared/SubSection.vue";
import '@/src/vee-validate.js';
import { savableStateMixin } from "@/src/mixins/savableStateMixin";
import TextInput from "@/src/components/shared/FormComponents/TextInput.vue";
import { Form as VeeForm } from 'vee-validate';
import TextArea from "@/src/components/shared/FormComponents/TextArea.vue";

export default {
  components: {
    CardSection,
    SubSection,
    ActionToolbar,
    TextInput,
    VeeForm,
    TextArea
  },
  mixins: [ savableStateMixin ],
  setup() {
    const notificationServiceStore = useNotificationServiceStore();
    return {
      notificationServiceStore
    }
  },
  data() {
    return {
      selectedService: {},
      successMessage: null,
    }
  },
  computed: {
    createNew() {
      return this.$route.params.id ? false : true;
    }
  },
  async mounted() {
    this.setSavableStateLoading();
    try {
      if(!this.createNew) {
        const record = await this.notificationServiceStore.loadService(this.$route.params.id);
        this.loadForm(record);
      }
      this.setSavableStateIdle();
    } catch(error) {
      this.handleMajorError(error);
    }
  },
  methods: {
    loadForm(record) {
      this.selectedService = {
        id: record.id,
        name: record.name,
        phoneNumber: record.notification_phone_number ? record.notification_phone_number.substring(2) : null,
        sms: record.sms,
        robocall: record.robocall,
        smsText: record.sms_text,
        robocallText: record.robocall_text
      }
    },
    async onSubmit() {
      let formattedPhoneNumber = null;
      if (this.selectedService.phoneNumber && !this.selectedService.phoneNumber.startsWith('+1')) {
        formattedPhoneNumber = '+1' + this.selectedService.phoneNumber;
      } else {
        formattedPhoneNumber = this.selectedService.phoneNumber;
      }
      try {
        this.setSavableStateProcessing()
        const payload = {
          name: this.selectedService.name,
          notification_phone_number: formattedPhoneNumber ? formattedPhoneNumber.replace(/-/g, '') : null,
          sms: this.selectedService.sms,
          robocall: this.selectedService.robocall,
          sms_text: this.selectedService.smsText,
          robocall_text: this.selectedService.robocallText
        }
        if (this.createNew) {
          const response = await this.notificationServiceStore.createService(payload)
          this.successMessage = 'Successfully created notification service!' 
          this.setSavableStateSuccess();
          this.$router.push({ name: 'admin_integrations_email_notifications_edit', params: { id: response.id } });
          this.loadForm(response);
        } else {
          payload.id = this.selectedService.id;
          await this.notificationServiceStore.updateService(payload)
          this.setSavableStateSuccess();
          this.successMessage = 'Successfully updated notification service!' 
        }
        this.setSavableStateSuccess();
      } catch(error) {
        this.handleFormError(error);
      }
    },
    cancel() {
      this.$router.push({ name: 'admin_integrations_email_notifications' });
    }
  }
}
</script>